import * as tokens from './tokens';

// Tema principal da aplicação
const theme = {
  // Spread de todos os tokens
  ...tokens.default,

  // Helpers para acesso rápido
  gradient: tokens.colors.primary.gradient,
  gradientHover: tokens.colors.primary.gradientHover,

  // Media queries helpers
  media: {
    xs: `@media (max-width: ${tokens.breakpoints.xs})`,
    sm: `@media (max-width: ${tokens.breakpoints.sm})`,
    md: `@media (max-width: ${tokens.breakpoints.md})`,
    lg: `@media (max-width: ${tokens.breakpoints.lg})`,
    xl: `@media (max-width: ${tokens.breakpoints.xl})`,
    xxl: `@media (max-width: ${tokens.breakpoints.xxl})`,
    // Min-width variants
    minXs: `@media (min-width: ${tokens.breakpoints.xs})`,
    minSm: `@media (min-width: ${tokens.breakpoints.sm})`,
    minMd: `@media (min-width: ${tokens.breakpoints.md})`,
    minLg: `@media (min-width: ${tokens.breakpoints.lg})`,
    minXl: `@media (min-width: ${tokens.breakpoints.xl})`,
  },

  // Função helper para criar gradientes customizados
  createGradient: (color1, color2, direction = '135deg') =>
    `linear-gradient(${direction}, ${color1}, ${color2})`,

  // Função helper para criar box-shadow com focus
  focusRing: (color = tokens.colors.primary.main) =>
    `0 0 0 3px ${color}40`,

  // Função helper para truncar texto
  truncate: `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  // Função helper para flexbox center
  flexCenter: `
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  // Função helper para grid responsivo
  gridAuto: (minWidth = '250px') => `
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(${minWidth}, 1fr));
    gap: ${tokens.spacing.md};
  `,
};

export default theme;
